export default __webpack_public_path__ + "static/media/xmas-slide1.bd7cad49.jpg";